var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 13.75H26.75C26.9489 13.75 27.1397 13.829 27.2803 13.9697C27.421 14.1103 27.5 14.3011 27.5 14.5V25.5C27.5 25.6989 27.421 25.8897 27.2803 26.0303C27.1397 26.171 26.9489 26.25 26.75 26.25H13.25C13.0511 26.25 12.8603 26.171 12.7197 26.0303C12.579 25.8897 12.5 25.6989 12.5 25.5V14.5C12.5 14.3011 12.579 14.1103 12.7197 13.9697C12.8603 13.829 13.0511 13.75 13.25 13.75ZM26 16.9285L20.054 22.2535L14 16.912V24.75H26V16.9285ZM14.3833 15.25L20.0457 20.2465L25.6265 15.25H14.3833Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIcon1);
export default __webpack_public_path__ + "static/media/connect_icon1.51b666077885c333314165584dad3ca5.svg";
export { ForwardRef as ReactComponent };